var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('label',{staticClass:"titlePage"},[_vm._v("Alterações - Candidatos")]),_c('fccTable',{attrs:{"striped":"","hover":"","responsive":"","search":"","pagination":"","fields":_vm.fields,"items":_vm.alteracoesCandidatos,"porPage":_vm.itemsPorPage}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }